module.exports = __webpack_public_path__ + "img/material_analyze_to_excel_style1.a072b588.png";